"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPriceEstimatePropertyDetailsDto = instanceOfPriceEstimatePropertyDetailsDto;
exports.PriceEstimatePropertyDetailsDtoFromJSON = PriceEstimatePropertyDetailsDtoFromJSON;
exports.PriceEstimatePropertyDetailsDtoFromJSONTyped = PriceEstimatePropertyDetailsDtoFromJSONTyped;
exports.PriceEstimatePropertyDetailsDtoToJSON = PriceEstimatePropertyDetailsDtoToJSON;
exports.PriceEstimatePropertyDetailsDtoToJSONTyped = PriceEstimatePropertyDetailsDtoToJSONTyped;
var PriceEstimateDto_1 = require("./PriceEstimateDto");
/**
 * Check if a given object implements the PriceEstimatePropertyDetailsDto interface.
 */
function instanceOfPriceEstimatePropertyDetailsDto(value) {
    if (!('isSupportedPropertyClass' in value) || value['isSupportedPropertyClass'] === undefined)
        return false;
    return true;
}
function PriceEstimatePropertyDetailsDtoFromJSON(json) {
    return PriceEstimatePropertyDetailsDtoFromJSONTyped(json, false);
}
function PriceEstimatePropertyDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'address': json['address'] == null ? undefined : json['address'],
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'primaryImageUrl': json['primaryImageUrl'] == null ? undefined : json['primaryImageUrl'],
        'lastSoldDate': json['lastSoldDate'] == null ? undefined : json['lastSoldDate'],
        'lastSoldPrice': json['lastSoldPrice'] == null ? undefined : json['lastSoldPrice'],
        'priceEstimate': json['priceEstimate'] == null ? undefined : (0, PriceEstimateDto_1.PriceEstimateDtoFromJSON)(json['priceEstimate']),
        'isSupportedPropertyClass': json['isSupportedPropertyClass'],
    };
}
function PriceEstimatePropertyDetailsDtoToJSON(json) {
    return PriceEstimatePropertyDetailsDtoToJSONTyped(json, false);
}
function PriceEstimatePropertyDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'title': value['title'],
        'address': value['address'],
        'streetAddress': value['streetAddress'],
        'primaryImageUrl': value['primaryImageUrl'],
        'lastSoldDate': value['lastSoldDate'],
        'lastSoldPrice': value['lastSoldPrice'],
        'priceEstimate': (0, PriceEstimateDto_1.PriceEstimateDtoToJSON)(value['priceEstimate']),
        'isSupportedPropertyClass': value['isSupportedPropertyClass'],
    };
}
